import React from "react";

const Misc = () => {
  return <div className="container"></div>;
};

export default Misc;
